// this is an autogenerated file from App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/ContactInfo/Email/NewEmail/Content/Content/Related/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Patients_Content_Content_Sections_ActiveTab_Profile_Content_ContactInfo_Email_NewEmail_Content_Content_Related($person_id: uuid!) {
  vaxiom_relationships(
    where: { to_person_record: { _id: { _eq: $person_id } } }
  ) {
    id
    type
    role
    to_person_record {
      id
      contact_method_associations {
        id
        contact_method_id
      }
    }
    from_person_record {
      id
      first_name
      middle_name
      last_name
      contact_method_associations(
        where: { contact_method: { dtype: { _eq: "email" } } }
        order_by: { contact_order: asc_nulls_first }
      ) {
        id
        contact_method_id
        email {
          id
          address
        }
      }
    }
  }
}

`